import React from 'react'

import RouteLayout from '../../RouteLayout'
import { Buttons, Form, Table } from './Components'
import Spinner from '../../common/Spinner'
import { useSelector } from 'react-redux'


export default function GraduatesHEO () {

  function groupByUniqueId(arr = []) {
    if (!arr) return 
      const grouped = arr.reduce((acc, obj) => {
        // Проверяем, существует ли уже группа с таким idorganization
        const existingGroup = acc.find(group => group[0].idorganization === obj.idorganization);
        
        if (existingGroup) {
          existingGroup.push(obj); // Добавляем объект в соответствующую группу
        } else {
          acc.push([obj]); // Создаем новую группу с первым объектом
        }
    
        return acc;
      }, []);
    
      return grouped;
    }
  
  const { loader, form, data, report_params } = useSelector(state => state.reports.graduatesOrientation)
  
  return (
    <RouteLayout title={'Сведения о мероприятиях военно-профессиональной ориентации выпускников'}>
      <Form form={form}/>
      <Buttons visible={!!data} data={groupByUniqueId(data)} reportParams={report_params}/>
      {loader
        ? <Spinner />
        : <Table data={groupByUniqueId(data)} reportParams={report_params}/>
      }
    </RouteLayout>
  )
}
